export * from "./error-404-page.component";
export * from "./error-404-page.resolver";
